// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__kJddf","btnComponent":"button_btnComponent__q743z","primary":"button_primary__AgcVi","secondary":"button_secondary__LcMAE"};